import { isMatch, parse, differenceInDays } from "date-fns";
import { useEffect, useState } from "react";
import { DATE_STRING_FORMAT } from "../../Constants/stringFormats";

export default function PricingAsOfCYQuarter(props) {
    const [pricingQuarter, setPricingQuarter] = useState(1);
    var today=new Date();

    useEffect(() => {
        if (!isMatch(props.pricingDataDate, DATE_STRING_FORMAT)) {
            setPricingQuarter(DateToQuarterString(today));
            return;
        }

        setPricingQuarter(DateToQuarterString(parse(props.pricingDataDate, DATE_STRING_FORMAT, new Date())));
    }, [props.pricingDataDate]);

    useEffect(() => {
        if (props.onChange) {
            props.onChange(pricingQuarter);
        }
    }, [pricingQuarter]);

    return (<span className="fw-bold">
        {pricingQuarter !== null && <>Using CMS Data As Of {pricingQuarter.toString().substring(0,4)} Quarter {pricingQuarter.toString().substring(4)}</>}
    </span>);
}

function DateToQuarterString(date)
{
    return String(date.getFullYear()) + String(Math.floor(date.getMonth()/3)+1);
}